const initTimeout = setTimeout(initLoad, 500);

function initLoad() {

  // attach events for Recharge radios to change price label
  var rc_radiomatches = document.getElementsByName('purchaseOption');

  if (rc_radiomatches) {
    for (match in rc_radiomatches) {
      rc_radiomatches[match].onchange = function() {
        let radioLabel = this.nextElementSibling.innerText;
        let result = radioLabel.match(/(\$[0-9]+(\.[0-9]{2})?)/);
        let pricetrim = result[0].slice(0, -3);

        document.getElementById('ProductPrice').innerHTML = pricetrim;
      }
    }
  }
}

// custom toggle ingredients, info and ways to eat
window.addEventListener('load',function(){
	//Ingredients Button
	const ingredbtn = document.getElementById("ingredientbtn");
	if (ingredbtn) {
		document.getElementById("ingredientbtn").addEventListener("click", (e) => {
		    e.preventDefault();

            let listbtn = document.getElementById("ingredientbtn");
		    let list = document.getElementById("ingredientslist");
		  	listbtn.classList.toggle("active");
		    list.classList.toggle("active");
		    
	    });
	}

	//More Info Button
	const moreinfobtn = document.getElementById("moreinfobtn");
	if (moreinfobtn) {
		document.getElementById("moreinfobtn").addEventListener("click", (e) => {
		    e.preventDefault();

            let morebtn = document.getElementById("moreinfobtn");
		    let moreinfolist = document.getElementById("moreinfolist");
		  	morebtn.classList.toggle("active");
		    moreinfolist.classList.toggle("active");
		    
	    });
	}

   //Ways To Eat Button
	const waystoeatbtn = document.getElementById("waystoeatbtn");
	if (waystoeatbtn) {
		document.getElementById("waystoeatbtn").addEventListener("click", (e) => {
		    e.preventDefault();

            let waysbtn = document.getElementById("waystoeatbtn");
		    let waystoeatlist = document.getElementById("waystoeatlist");
		  	waysbtn.classList.toggle("active");
		    waystoeatlist.classList.toggle("active");
		    
	    });
	}
});